import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable()
export class HttpClientService {

  constructor(private http: HttpClient) {}

  getToken() {
    let token = '';

    if (environment.mockToken) {
      token = environment.chaveToken;
    } else {
      token = sessionStorage.getItem('loginAuth');
    }

    return token;
  }

  get(url: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + this.getToken()
      })
    };
    return this.http.get<any>(url, httpOptions);
  }

  getToDocument(url: any) {
    const httpOptions = new HttpHeaders({
      'Authorization':'Bearer '+ this.getToken()
    });
 
    return this.http.get(url, { responseType: 'text', headers: httpOptions });
  }

  post(url: any, data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + this.getToken()
      })
    };

    return this.http.post<any>(url, data, httpOptions);
  }

  delete(url: any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + this.getToken()
      })
    };

    return this.http.delete<any>(url, httpOptions);
  }

  put(url: any, data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + this.getToken()
      })
    };

    return this.http.put<any>(url, data, httpOptions);
  }

  patch(url: any, data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + this.getToken()
      })
    };

    return this.http.patch<any>(url, data, httpOptions);
  }
  
}
